import CandidateVideoGrid from '@components/CandidateVideoGrid';
import CandidateVideos from '@components/CandidateVideos';
import ContentShare from '@components/ContentShare';
import type { BaseComponentProps } from '@interfaces/selection';
import { useContentShareState } from '@providers/ContentShareProvider';
import { type FC, type PropsWithChildren } from 'react';

interface CandidateVideoTileGridProps extends BaseComponentProps {}

const CandidateVideoTileGrid: FC<
  PropsWithChildren<CandidateVideoTileGridProps>
> = ({ ...rest }) => {
  const { tileId: contentTileId } = useContentShareState();

  return (
    <CandidateVideoGrid {...rest}>
      {contentTileId && <ContentShare />}
      <CandidateVideos />
    </CandidateVideoGrid>
  );
};

export default CandidateVideoTileGrid;
